"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
const UndergroundToken_vue_1 = require("./UndergroundToken.vue");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'UndergroundTokens',
    components: {
        UndergroundToken: UndergroundToken_vue_1.default,
    },
    props: {
        underworldData: {
            type: Object,
            required: true,
        },
    },
    methods: {
        border(token) {
            return token.active ? 'underground-token-border' : '';
        },
    },
});
